module.exports = __webpack_public_path__ + "static/media/footer-phone-web.db755e84.svg";